export default __webpack_public_path__ + "static/media/anniversarymob1.28740247.webp";